// src/modules/Upsell/instances/experiments/web_unify_upsell_second_screen.ts
import type { UpsellTemplateSchema, UpsellComponentsConfig, UpsellStepsArgs } from '../@types/upsell-types'
import { mergeDeep } from '@/helpers/utils'
import giftBgPng from '@/assets/upsell/gift-bg.png'
import giftModalCheckedLilacSvg from '@/assets/upsell/gift-modal-checked-lilac.svg'

export default (schema: UpsellTemplateSchema): UpsellTemplateSchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				steps: (args: UpsellStepsArgs) => {
					const baseSteps = schema.config.steps(args)
					return baseSteps.map((step, index) => ({
						...step,
						...(index === 0 ? { modals: { skip: ['UpsellSkipUnwrapModal', 'UpsellSkipAnimationModal'] } } : {}),
					}))
				},
			},
			components: {
				UpsellHead: ({ ctx, $t }): UpsellComponentsConfig['UpsellHead'] => ({
					...schema.components.UpsellHead({ ctx, $t }),
					dynamicLogoColor: true,
				}),
				UpsellGiftBadge: ({ $t, ctx }): UpsellComponentsConfig['UpsellGiftBadge'] => ({
					...schema.components.UpsellGiftBadge({ $t, ctx }),
					text: $t('pages.workbooks_bundle.additional_discount', { percent: 60 }),
				}),
				UpsellSkipUnwrapModal: ({ ctx }): UpsellComponentsConfig['UpsellSkipUnwrapModal'] => ({
					show: ctx.visibleModal === 'UpsellSkipUnwrapModal',
					image: giftBgPng,
				}),
				UpsellSkipAnimationModal: ({ $t, ctx }): UpsellComponentsConfig['UpsellSkipAnimationModal'] => ({
					show: ctx.visibleModal === 'UpsellSkipAnimationModal',
					loading: ctx.loading,
					scrollTo: 'top',
					title: $t('female_activity.pages.upsell.discount_modal.title', { discount: 60 }),
					text: [
						$t('female_activity.pages.upsell.discount_modal.subtitle', { discount: 60 }),
						`<b>${$t('female_activity.pages.upsell.discount_modal.note', { price: ctx.product.otp.localizedPrice })}</b>`,
					].join('<br><br>'),
					buttonText: $t('female_activity.pages.upsell.discount_modal.claim_now'),
					icon: giftModalCheckedLilacSvg,
					handleBackdropClicks: true,
					showCloseButton: true,
					purchaseByClick: true,
					buttonColor: 'success',
					closeButtonOpaque: true,
				}),
			},
		},
	)
